export default __webpack_public_path__ + "media/images/open-graph-image-e371e8465a4250bc5857865e6e43ff37.png";